import { useCallback, useState } from 'react';

export interface UseAiChatResult {
    isChatUnavailable: boolean;
    setIsChatUnavailable: (isUnavailable: boolean) => void;
    /** Opens the Dialog Intelligens chatbot with `message` prefilled. Returns whether it opened. */
    openChat: (message: string) => boolean;
}

/**
 * Shared entry point into the Dialog Intelligens chatbot (`window.DialogIntelligens`), used by
 * both the PDP AI chat prompt and the PLP AI product guide banner.
 */
export const useAiChat = (): UseAiChatResult => {
    const [isChatUnavailable, setIsChatUnavailable] = useState(false);

    const openChat = useCallback((message: string) => {
        const chatbot = window.DialogIntelligens;

        if (!chatbot?.open) {
            // Inform the user that chat is unavailable if it is unavailable or results in an error.
            setIsChatUnavailable(true);

            return false;
        }

        try {
            chatbot.open(message);

            window.dispatchEvent(
                new CustomEvent('chat_open', { detail: { chat_type: 'shopping_assistant' } }),
            );

            setIsChatUnavailable(false);

            return true;
        } catch (error) {
            console.error(error);

            setIsChatUnavailable(true);

            return false;
        }
    }, []);

    return { isChatUnavailable, setIsChatUnavailable, openChat };
};
